import React from 'react';
import { useSelector } from 'react-redux';
import { LTBox, LTText } from '@lambdatestincprivate/lt-components';
import { IssueTypes, WCAGMapping } from './constants';
import { useTheme } from 'styled-components';

const getAccessibilityLevel = (data = {}) => {
  const {
    critical_issues,
    serious_issues,
    moderate_issues,
    minor_issues,
  } = data;

  return critical_issues > 0
    ? IssueTypes.CRITICAL
    : serious_issues > 0
    ? IssueTypes.SERIOUS
    : moderate_issues > 0
    ? IssueTypes.MODERATE
    : minor_issues > 0
    ? IssueTypes.MINOR
    : '';
};

const IssueTypeTextColorMap = {
  Critical: '#CF222E',
  Serious: '#9A6700',
  Moderate: '#176F2C',
  Minor: '#333',
};

const AccessibilitySummary = ({ totalIssuesCount }) => {
  const { details: accessibilityData } = useSelector(
    (state) => state.accessibility
  );
  const theme = useTheme();

  const summaryList = [
    { label: 'Status', value: getAccessibilityLevel(accessibilityData) },
    {
      label: 'WCAG Version',
      value: WCAGMapping?.[accessibilityData?.wcag_version],
    },
    { label: 'Total Issues', value: totalIssuesCount },
    { label: 'Issue Types', value: accessibilityData?.issue_type },
    {
      label: 'Affected Views',
      value: accessibilityData?.affected_view_count,
    },
    {
      label: 'Affected WCAG Guidelines',
      value: accessibilityData?.affected_wcag_guidelines,
    },
    {
      label: 'Affected Element Group',
      value: accessibilityData?.affected_element_group,
    },
  ];

  return (
    <LTBox
      flex="1"
      display="flex"
      gridGap="16px"
      flexWrap="wrap"
      marginTop="24px"
    >
      {summaryList.map((summaryData) => (
        <LTBox
          key={summaryData?.label}
          width="calc(33.33% - 11px)"
          minWidth="210px"
          border="1px solid"
          borderColor={theme?.colors?.border?.default}
          borderRadius="6px"
          padding="12px"
        >
          <LTText fontSize={LTText.FontSize.FONT_14} fontWeight="400">
            {summaryData.label}
          </LTText>
          <LTText
            fontSize={LTText.FontSize.FONT_20}
            fontWeight="600"
            marginTop="4px"
            color={
              summaryData.label === summaryList[0].label
                ? IssueTypeTextColorMap[summaryData.value]
                : null
            }
          >
            {summaryData.value || '0'}
          </LTText>
        </LTBox>
      ))}
    </LTBox>
  );
};

export default AccessibilitySummary;
